import React from 'react';
import Header from '../../components/ui/Header';
import ArticleHero from './components/ArticleHero';
import ArticleContent from './components/ArticleContent';
import InteractiveDemo from './components/InteractiveDemo';
import CaseStudies from './components/CaseStudies';
import RelatedArticles from './components/RelatedArticles';
import AuthorBio from './components/AuthorBio';
import CTASection from './components/CTASection';
import Image from '../../components/AppImage';

const AIAutomotiveExcellenceArticle = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      {/* Main Content */}
      <main className="pt-16">
        <ArticleHero />
        <ArticleContent />
        <InteractiveDemo />
        <CaseStudies />
        <AuthorBio />
        <RelatedArticles />
        <CTASection />
      </main>
      {/* Footer */}
      <footer className="bg-gradient-to-r from-slate-900 via-blue-900 to-indigo-900 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Company Info */}
            <div className="col-span-1 md:col-span-2 space-y-6">
              <div className="flex items-center space-x-4 mb-6">
                <div className="w-16 h-16 flex items-center justify-center">
                  <Image
                    src="/assets/images/logo_CRF_PERFECTION_4x-1761998753526.png"
                    alt="CRF PERFECTION logo featuring interlocking heart-shaped design in red and gold colors representing Centre de Recherche et de Formation business therapy excellence"
                    className="w-full h-full object-contain"
                  />
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-white">CRF PERFECTION</h3>
                  <p className="text-blue-200 font-semibold">Centre de Recherche et de Formation</p>
                  <p className="text-gray-300 text-sm">Excellence IA Automobile</p>
                </div>
              </div>
              <p className="text-blue-100 mb-6 leading-relaxed max-w-2xl">
                Expert en Intelligence Artificielle pour l'industrie automobile africaine. 
                Découvrez comment transformer votre service automobile avec nos solutions IA innovantes.
              </p>
            </div>

            {/* Quick Links */}
            <div className="space-y-4">
              <h4 className="text-lg font-semibold mb-4 text-white">Navigation</h4>
              <ul className="space-y-3 text-blue-100">
                <li><a href="/blog-hub" className="hover:text-white transition-colors duration-200 text-sm flex items-center space-x-2">
                  <span className="w-1.5 h-1.5 bg-purple-400 rounded-full"></span>
                  <span>Retour au Blog</span>
                </a></li>
                <li><a href="#article-content" className="hover:text-white transition-colors duration-200 text-sm flex items-center space-x-2">
                  <span className="w-1.5 h-1.5 bg-blue-400 rounded-full"></span>
                  <span>Contenu Principal</span>
                </a></li>
                <li><a href="#case-studies" className="hover:text-white transition-colors duration-200 text-sm flex items-center space-x-2">
                  <span className="w-1.5 h-1.5 bg-green-400 rounded-full"></span>
                  <span>Cas d'Études</span>
                </a></li>
                <li><a href="#interactive-demo" className="hover:text-white transition-colors duration-200 text-sm flex items-center space-x-2">
                  <span className="w-1.5 h-1.5 bg-red-400 rounded-full"></span>
                  <span>Démo Interactive</span>
                </a></li>
              </ul>
            </div>

            {/* Expert Contact */}
            <div className="space-y-4">
              <h4 className="text-lg font-semibold mb-4 text-white">Expert IA Automobile</h4>
              <div className="space-y-4 text-blue-100">
                <div className="flex items-center space-x-3">
                  <div className="w-8 h-8 bg-purple-600/30 rounded-lg flex items-center justify-center">
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
                    </svg>
                  </div>
                  <span className="text-sm">Dr. Sarah Kouassi</span>
                </div>
                <div className="flex items-center space-x-3">
                  <div className="w-8 h-8 bg-blue-600/30 rounded-lg flex items-center justify-center">
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
                    </svg>
                  </div>
                  <span className="text-sm">ai-automotive@crfperfection.com</span>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="border-t border-blue-400/20 mt-12 pt-8">
            <div className="flex flex-col lg:flex-row justify-between items-center space-y-4 lg:space-y-0">
              <div className="text-center lg:text-left">
                <p className="text-blue-200 text-sm">
                  © {new Date()?.getFullYear()} CRF PERFECTION - Intelligence Artificielle au Service de l'Excellence Automobile.
                </p>
              </div>
              <div className="flex flex-wrap justify-center lg:justify-end space-x-6">
                <a href="/blog-hub" className="text-blue-200 hover:text-white text-sm transition-colors duration-200">
                  Blog
                </a>
                <a href="/ai-solutions-integration-hub" className="text-blue-200 hover:text-white text-sm transition-colors duration-200">
                  Solutions IA
                </a>
                <a href="/contact" className="text-blue-200 hover:text-white text-sm transition-colors duration-200">
                  Contact Expert
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default AIAutomotiveExcellenceArticle;